document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.pp-card__header').forEach(function(header) {
    header.addEventListener('click', function() {
      var card = this.closest('.pp-card');
      var id = card.id;
      var body = document.getElementById('body-' + id);
      var badge = document.getElementById('badge-' + id);
      var chev = document.getElementById('chev-' + id);
      var isOpen = body.classList.contains('open');
      if (isOpen) {
        body.classList.remove('open');
        badge.classList.remove('open');
        chev.classList.remove('open');
      } else {
        body.classList.add('open');
        badge.classList.add('open');
        chev.classList.add('open');
      }
    });
  });
});